module.exports = __webpack_public_path__ + "static/logo-7e0a3341b55ca8a25827544ba7b1564d.svg";